<template>
    <div>
        <div style="margin-bottom: 15px">
            <span>当前积分：{{point}}</span>
            <a-button type="primary" style="margin-left: 15px" @click="$refs.createForm.showForm({})">新增</a-button>
            <span style="margin-left: 5%">（不支持直接删除操作，可将总量调整为与兑换量一致实现下架操作）</span>
        </div>
        <a-divider>消费券列表</a-divider>
        <a-table
                :columns="columns"
                :data-source="rows"
                :pagination="pagination"
                @change="handleTableChange"
                style="width: 100%;"
                bordered>
            <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
            <a slot="imageUrl" slot-scope="text, record, index" :href="text.startsWith('http')?text:'http://'+text" target="_blank">查看</a>

            <template slot="action" slot-scope="text, record">
                <a-button type="link" style="padding: 0; margin-left: 10px" @click="$refs.updateForm.showForm(record)">更新</a-button>
                <a-divider type="vertical"></a-divider>
                <a-button type="link" style="padding: 0; margin-left: 10px" @click="$refs.exchangeRecord.showModal(record.id)">兑换记录</a-button>
            </template>
        </a-table>

        <create-form ref="createForm" @create="handleCreate"></create-form>
        <update-form ref="updateForm" @update="handleUpdate"></update-form>
        <exchange-record ref="exchangeRecord"></exchange-record>

    </div>
</template>

<script>

    import vendorAdminService from "../../service/vendorAdmin";
    import moment from "moment"
    import CreateForm from "./CreateForm";
    import UpdateForm from "./UpdateForm";
    import ExchangeRecord from "./ExchangeRecord";

    export default {
        components: {CreateForm, UpdateForm, ExchangeRecord},
        data() {
            return {
                columns: [
                    {title: '#', width: "6%", scopedSlots: { customRender: 'serial' }},
                    {title: '面值',width: "10%", dataIndex: 'value', align: 'center'},
                    {title: '优惠券logo',width: "10%", dataIndex: 'imageUrl', align: 'center', scopedSlots: {customRender: 'imageUrl'}},
                    {title: '所需积分',width: "10%", dataIndex: 'point', align: 'center',},
                    {title: '发行数量',width: "10%", dataIndex: 'totalAmount', align: 'center', scopedSlots: {customRender: 'amount'}},
                    {title: '已兑换量',width: "10%", dataIndex: 'consumeAmount', align: 'center',},
                    {title: '更新时间',width: "18%", dataIndex: 'updateTime', align: 'center', customRender: (text) => moment(new Date(text)).format("YYYY-MM-DD HH:mm:ss")},
                    {title: '操作', width: "18%", dataIndex: 'action', align: 'center', scopedSlots: {customRender: 'action'},},
                ],
                rows: [],
                pagination: {},

                point: 0
            }
        },
        mounted() {
            let params = {
                pageNo: 1,
                pageSize: 5,
            }
            this.fetch(params)
        },
        methods: {
            handleTableChange(pagination) {
                this.fetch({
                    pageNo: pagination.current,
                    pageSize: pagination.pageSize,
                    keyword: this.keyword
                })
            },
            fetch(params) {
                vendorAdminService.couponList(params).then((res) => {
                    const pagination = { ...this.pagination };
                    this.rows = res.data.record.records

                    for(let row of this.rows) {
                    }

                    pagination.current = res.data.record.current
                    pagination.total = res.data.record.total
                    pagination.pageSize = res.data.record.size
                    pagination.showTotal = (total, range) => {
                        return `${range[0]}-${range[1]} of ${total} items`
                    }

                    this.point = res.data.point
                    this.pagination = pagination
                });
            },
            handleCreate(values) {
                vendorAdminService.createCoupon( values).then((res) => {
                    this.$success({
                        title: "创建成功！"
                    })
                    this.$refs.createForm.confirmLoading = false
                    this.$refs.createForm.visible = false

                    this.fetch({
                        pageNo: 1,
                        pageSize: this.pagination.pageSize,
                    })
                }).catch((res)=>{
                    this.$refs.createForm.confirmLoading = false
                })
            },
            handleUpdate(values) {
                vendorAdminService.updateCoupon( values).then((res) => {
                    this.$success({
                        title: "更新成功！"
                    })
                    this.$refs.updateForm.confirmLoading = false
                    this.$refs.updateForm.visible = false

                    this.fetch({
                        pageNo: 1,
                        pageSize: this.pagination.pageSize,
                    })
                }).catch((res)=>{
                    this.$refs.updateForm.confirmLoading = false
                })
            }
        }
    }
</script>

<style scoped>

</style>
